import Breadcrumbs, { CrumbItem } from '../components/seo/Breadcrumbs'
import { breadcrumbSchema } from './schema'

type Tone = 'dark' | 'light'

/** One definition per page feeds BOTH the visual breadcrumb and the
    BreadcrumbList JSON-LD — use this helper to keep them in sync. */
export function useBreadcrumbs(
  items: CrumbItem[],
  tone: Tone = 'dark',
): { node: React.ReactNode; jsonLd: object } {
  return {
    node: <Breadcrumbs items={items} tone={tone} />,
    jsonLd: breadcrumbSchema(items),
  }
}
